import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

import { QuestionOption, QuestionPrefix, QuestionType, VariableRequiredType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { IQuestionOptionForm } from './question-form-group.interface';
import { QuestionForm } from './question-form.model';
import { QuestionOptionForm } from './question-option-form.model';

export class QuestionFormSourceVariable extends QuestionForm {
  constructor() {
    super();
    this.extendFormGroup();
  }

  get options(): FormArray<FormGroup<IQuestionOptionForm>> {
    return this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>;
  }

  initEmpty(nextId: number): void {
    this.form.patchValue({ id: `${QuestionPrefix.SourceVariable}${nextId}`, code: `${QuestionPrefix.SourceVariable}${nextId}` });
  }

  init(question: Question): void {
    super.init(question);

    if (question.type === QuestionType.SingleChoice) {
      this.patchOptions(question.options);
    }
  }

  setTakenTokens(takenTokens: string[]): void {
    const variableTokenCtrl = this.form.get('variableToken');

    variableTokenCtrl.addValidators(this.duplicateToken(takenTokens));
    variableTokenCtrl.updateValueAndValidity();
  }

  private extendFormGroup(): void {
    this.form.addControl('options', new FormArray<FormGroup<IQuestionOptionForm>>([]));
    this.form.addControl('variableRequiredType', new FormControl<VariableRequiredType>(null, Validators.required));
    this.form.addControl('variableToken', new FormControl<string>('', [Validators.required, this.cannotContainSpace]));

    const typeCtrl = this.form.get('type');
    typeCtrl.addValidators(Validators.required);
    typeCtrl.updateValueAndValidity();
  }

  private patchOptions(options: QuestionOption[]): void {
    if (!options || options.length === 0) {
      return;
    }

    options.forEach((option) => {
      (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm(option).form);
    });
  }

  private cannotContainSpace(control: AbstractControl): ValidationErrors | null {
    const value = (control.value as string) ?? '';

    return value.includes(' ') ? { isCustom: true, message: 'Variable name can not contain spaces' } : null;
  }

  private duplicateToken(takenTokens: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = ((control.value as string) ?? '').trim().toLowerCase();

      if (!value) {
        return null;
      }

      const isDuplicate = takenTokens.some((takenToken) => takenToken.trim().toLowerCase() === value);

      return isDuplicate ? { isCustom: true, message: 'Name already exists in source' } : null;
    };
  }
}
